<template>
  <div :class="[courseSize, 'tool_bar']">
    <!--举手-->
    <div
      :class="['type', 'hand', isHand ? 'active' : '']"
      @click="() => this.$emit('onSetHand')"
    >
      <i class="icon"></i>
      举手
    </div>
    <!--消息-->
    <div :class="['type', 'msg', show ? 'active': '']" @click="showMsgBox">
      <i class="icon"></i>
      聊天
    </div>
    <!--退出-->
    <div class="type quit" @click="() => this.$emit('quit')">
      <i class="icon"></i>
      退出
    </div>
    <div :class="['msg_box', show ? 'active' : '']">
      <div class="title">在线人数：{{ number }}人</div>
      <ul id="msg_box" class="im-log-box">
        <li v-for="(msg, index) in msgs" :class="msg.type || ''" :key="index">
          <div v-if="msg.type === 'left'">
            <span class="send time">{{ msg.time ? msg.time : "" }}</span>
            <div
              :class="[
                'name',
                msg.id === teacher ? 'teacher' : msg.id === mine ? 'mine' : ''
              ]"
            >
              {{ msg.send }}
            </div>
            <div class="content_box clearfix">
              <div :class="['content', msg.id === mine ? 'mine' : '']">
                {{ msg.content }}
              </div>
            </div>
          </div>
          <div v-else>
            <span class="send">{{ msg.send }} {{ msg.content }}</span>
            <span v-if="msg.time" class="send time">{{ msg.time }}</span>
          </div>
        </li>
      </ul>
      <div class="msg_input">
        <input
          :disabled="silence"
          type="text"
          placeholder="请输入内容，按回车发送"
          v-model="imMsg.common.data"
          @keydown.enter="sendMsg"
        />
        <div class="btn" @click="sendMsg">发送</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ToolBar",
  props: {
    courseSize: {
      type: String,
      default: ""
    },
    isHand: {
      type: Boolean,
      default: false
    },
    imMsg: {
      type: Object,
      default: () => {}
    },
    msgs: {
      type: Array,
      default: () => []
    },
    silence: {
      type: Boolean,
      default: false
    },
    number: {
      type: Number,
      default: 0
    },
    mine: {
      type: String,
      default: ""
    },
    teacher: {
      type: String,
      default: ""
    }
  },
  watch: {
    msgs() {
      this.$nextTick(() => {
        const msgbox = document.querySelector("#msg_box");
        msgbox.scrollTop = msgbox.scrollHeight;
      });
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    sendMsg() {
      this.$emit("onSendMsg", this.imMsg.common.data);
    },
    showMsgBox() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
.tool_bar {
  position: absolute;
  right: 1.85vh;
  top: 1.85vh;
  width: 6.67vh;
  height: auto;
  background: #24252c;
  padding: 0.93vh 0;
  z-index: 12;
  .type {
    display: block;
    width: 100%;
    height: 7.96vh;
    box-sizing: border-box;
    padding: 0.93vh;
    text-align: center;
    font-size: 1.3vh;
    color: #eee;
    cursor: pointer;
    background: none;
    .icon {
      display: block;
      width: 3.7vh;
      height: 3.7vh;
      margin: 0 auto 1vh;
    }
    &.hand {
      .icon {
        background: url("../../../assets/images/live_room/icon_hand.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &.msg {
      .icon {
        background: url("../../../assets/images/live_room/icon_msg.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &.quit {
      .icon {
        background: url("../../../assets/images/live_room/icon_quit.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
    &:hover,
    &.active {
      color: #ffca4a;
      background: rgba(0, 0, 0, 0.21);
      &.hand {
        .icon {
          background: url("../../../assets/images/live_room/icon_hand_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      &.msg {
        .icon {
          background: url("../../../assets/images/live_room/icon_msg_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
      &.quit {
        .icon {
          background: url("../../../assets/images/live_room/icon_quit_s.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .msg_box {
    width: 0;
    height: 60.28vh;
    opacity: 0;
    transition: all 0.5s ease;
    position: absolute;
    right: 8vh;
    top: 0;
    z-index: 999;
    text-align: left;
    background: #1a1a1a;
    border-radius: 0.56vh;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.17);
    .title {
      width: 100%;
      height: 3.06vh;
      line-height: 3.06vh;
      font-size: 1.3vh;
      color: #ffca4a;
      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(227, 227, 227, 0.22) 51%,
        rgba(255, 255, 255, 0) 100%
      );
      position: relative;
      text-align: center;
    }
    .im-log-box {
      width: 100%;
      height: 52.8vh;
      margin: 0;
      box-sizing: border-box;
      padding: 1.85vh 0;
      overflow-y: auto;
      overflow-x: hidden;
      &::-webkit-scrollbar {
        display: none;
      }
      li {
        padding: 0 2vh;
        font-size: 1.48vh;
        color: #fff;
        line-height: 3vh;
        text-align: left;
        box-sizing: border-box;
        &.left {
          width: 100%;
          padding: 1vh 2vh 0 2vh;
          span {
            width: 100%;
            display: block;
            word-wrap: break-word;
            word-break: break-all;
          }
        }
        .time {
          display: block;
          text-align: center;
        }
        &.center {
          text-align: center;
          color: #999;
          .time {
            display: inline;
            margin-left: 1vh;
          }
        }
        .name {
          font-size: 1.3vh;
          color: rgba(255, 255, 255, 0.4);
          text-align: left;
          &.mine {
            text-align: right;
          }
          &.teacher {
            color: #2cc590;
          }
        }
        .content_box {
          width: 100%;
          min-height: 5vh;
          .content {
            float: left;
            max-width: 100%;
            background: #fff;
            color: #dedede;
            padding: 0.5vh 1vh;
            line-height: 3.15vh;
            border-radius: 0 1.9vh 1.9vh 1.9vh;
            background: rgba(255, 255, 255, 0.15);
            margin-bottom: 1vh;
            word-break: break-word;
            &.mine {
              float: right;
              border-radius: 1.9vh 0 1.9vh 1.9vh;
            }
          }
        }
      }
    }
    .msg_input {
      box-sizing: border-box;
      background: #474b51;
      width: 100%;
      height: 4.26vh;
      padding: 0.65vh 0.65vh 0.46vh 0.65vh;
      display: flex;
      background: rgba(254, 254, 254, 0.05);
      input {
        flex: 0 0 39vh;
        width: 39vh;
        height: 100%;
        padding-left: 1vh;
        box-sizing: border-box;
        line-height: 5vh;
        font-size: 1.5vh;
        background: rgba(255, 255, 255, 0.08);
        color: #fff;
        border: none;
        border-radius: 0.37vh;
      }
      .btn {
        margin-left: 0.74vh;
        flex: 0 0 5.56vh;
        width: 5.56vh;
        height: 100%;
        background: #ffb80b;
        border-radius: 0.37vh;
        color: #fff;
        line-height: 3.15vh;
        text-align: center;
        font-size: 1.3vh;
        cursor: pointer;
      }
    }
    &.active {
      width: 46.48vh;
      opacity: 1;
      transition: all 0.5s ease;
    }
  }
  &.maximize {
    background: rgba(36, 37, 44, 0.4);
    .type {
      .icon {
        opacity: 0.6;
      }
    }
  }
}
</style>
